import React from 'react'

const GoalOverdueIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2411 16.3525L11.0438 2.14409C10.9088 1.87439 10.7061 1.64851 10.4574 1.49091C10.2087 1.33331 9.92364 1.25 9.63301 1.25C9.34238 1.25 9.05729 1.33331 8.80862 1.49091C8.55995 1.64851 8.35717 1.87439 8.22227 2.14409L1.02496 16.3525C0.891974 16.6128 0.826019 16.9049 0.833594 17.2001C0.841169 17.4953 0.922012 17.7833 1.06816 18.0358C1.20893 18.2844 1.40913 18.4902 1.64903 18.633C1.88892 18.7758 2.1602 18.8506 2.4361 18.85H16.8299C17.1058 18.8506 17.3771 18.7758 17.617 18.633C17.8569 18.4902 18.0571 18.2844 18.1979 18.0358C18.344 17.7833 18.4248 17.4953 18.4324 17.2001C18.44 16.9049 18.374 16.6128 18.2411 16.3525Z"
        fill="#E01E4E"
      />
      <path
        d="M10.4 6.7998L10 13.1998H9.20005L8.80005 6.7998H10.4Z"
        fill="white"
      />
      <path
        d="M9.60005 16.3998C10.0419 16.3998 10.4 16.0416 10.4 15.5998C10.4 15.158 10.0419 14.7998 9.60005 14.7998C9.15822 14.7998 8.80005 15.158 8.80005 15.5998C8.80005 16.0416 9.15822 16.3998 9.60005 16.3998Z"
        fill="white"
      />
    </svg>
  )
}

export default GoalOverdueIcon
